import { CSSProperties } from 'react';

export const EditFormInputStyle: CSSProperties = {
  margin: '0.5rem 0',
};
